import { create } from 'zustand';
import api from '../lib/api';

const useTourStore = create((set, get) => ({
  // State
  tours: [],
  currentTour: null,
  loading: false,
  error: null,
  filters: {
    status: null,
    lang: null,
  },

  // Actions
  setFilters: (filters) => set({ filters }),

  fetchTours: async () => {
    set({ loading: true, error: null });
    try {
      const data = await api.getTours(get().filters);
      set({ tours: data.tours || [], loading: false });
    } catch (error) {
      set({ error: error.message, loading: false });
    }
  },

  fetchTour: async (id) => {
    set({ loading: true, error: null });
    try {
      const tour = await api.getTour(id);
      set({ currentTour: tour, loading: false });
    } catch (error) {
      set({ error: error.message, loading: false });
    }
  },

  createTour: async (data) => {
    set({ loading: true, error: null });
    try {
      const tour = await api.createTour(data);
      set((state) => ({
        tours: [tour, ...state.tours],
        loading: false,
      }));
      return tour;
    } catch (error) {
      set({ error: error.message, loading: false });
      throw error;
    }
  },

  updateTour: async (id, data) => {
    set({ loading: true, error: null });
    try {
      const updated = await api.updateTour(id, data);
      set((state) => ({
        tours: state.tours.map((t) => (t.id === id ? updated : t)),
        currentTour: state.currentTour?.id === id ? updated : state.currentTour,
        loading: false,
      }));
      return updated;
    } catch (error) {
      set({ error: error.message, loading: false });
      throw error;
    }
  },

  deleteTour: async (id) => {
    set({ loading: true, error: null });
    try {
      await api.deleteTour(id);
      set((state) => ({
        tours: state.tours.filter((t) => t.id !== id),
        loading: false,
      }));
    } catch (error) {
      set({ error: error.message, loading: false });
      throw error;
    }
  },

  clearError: () => set({ error: null }),
}));

export default useTourStore;
